export enum ArticleRelativeBrand {
  SEGAFREDO = 'segafredo',
  NORDSEE = 'nordsee',
  COFFEE_FELLOWS = 'coffee_fellows',
  DALLMAYR = 'dallmayr',
}
